module.exports = __webpack_public_path__ + "static/media/web-programming.a8a75d58.png";